import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import {
  addLoyaltyCardsAction,
  deleteLoyaltyCardAction,
  getAppleWalletPassAction,
  getGoogleWalletPassAction,
  loadLoyaltyCardsAction,
} from './loyalty-cards.actions';
import { ILoyaltyCardsFeature } from './loyalty-cards.feature.state';
import { failures, getAppleWalletPass, getGoogleWalletPass, getLoyaltyCards, isLoading } from './loyalty-cards.selectors';

@Injectable()
export class LoyaltyCardsFacade {
  public isLoading$ = this.store.select(isLoading);
  public failures$ = this.store.select(failures);
  public LoyaltyCards$ = this.store.select(getLoyaltyCards);
  public getGoogleWalletPass$ = this.store.select(getGoogleWalletPass);
  public getAppleWalletPass$ = this.store.select(getAppleWalletPass);

  constructor(private store: Store<ILoyaltyCardsFeature>) {}

  public loadLoyaltyCards(): void {
    this.store.dispatch(loadLoyaltyCardsAction());
  }
  public addLoyaltyCards(CardID: number): void {
    this.store.dispatch(addLoyaltyCardsAction({ loyaltyCardID: CardID }));
  }
  public deleteLoyaltyCard(loyaltyCardID: number) {
    this.store.dispatch(deleteLoyaltyCardAction({ loyaltyCardID }));
  }

  public getGoogleWalletPass(): void {
    this.store.dispatch(getGoogleWalletPassAction());
  }

  public getAppleWalletPass(): void {
    this.store.dispatch(getAppleWalletPassAction());
  }
}
